import React, { Fragment } from "react";
import { Media } from "reactstrap";
import { Image } from "../../../AbstractElements";
import Emoji from "../../../assets/images/crypto-dashboard/emoji.png";
import ChatUser1 from "../../../assets/images/avtar/chat-user-1.png";
import ChatUser2 from "../../../assets/images/avtar/chat-user-2.png";
import { Gallery, Item } from "react-photoswipe-gallery";
import { Link } from "react-router-dom";

const ChatMessage = () => {
  const images = [
    "rectangle-26.png",
    "rectangle-27.png",
  ];

  return (
    <Fragment>
      <Media className="right-side-chat">
        <Media body>
          <div className="msg-box">
            Well I am not sure. The rest of the team is not here yet
            <Image attrImage={{ className: "img-fluid", src: `${Emoji}`, alt: "" }}/>
          </div>
        </Media>
        <div className="square-box ms-2">
          <a href="#javascript">
            <Image attrImage={{ src: `${ChatUser2}`, alt: "" }} />
          </a>
        </div>
      </Media>
      <Media className="left-side-chat">
        <div className="square-box">
          <a href="#javascript">
            <Image attrImage={{ src: `${ChatUser1}`, alt: "",}}
            />
          </a>
        </div>
        <Media body>
          <div className="img-msg-box">
            <Gallery>
              {images &&
                images.map((item, i) => {
                  return (
                      <Item original={require(`../../../assets/images/dashboard-2/${item}`)} width="1024" height="768" key={i}>
                        {({ ref, open }) => (
                          <Link onClick={open}>
                            <img className="img-thumbnail d-inline-block" ref={ref} src={require(`../../../assets/images/dashboard-2/${item}`)} alt=""/>
                          </Link>
                        )}
                      </Item>
                  );
                })}
            </Gallery>
          </div>
        </Media>
      </Media>
    </Fragment>
  );
};
export default ChatMessage;
